import { render, staticRenderFns } from "./detailRelation.vue?vue&type=template&id=30c0397e&scoped=true&"
import script from "./detailRelation.vue?vue&type=script&lang=js&"
export * from "./detailRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c0397e",
  null
  
)

export default component.exports